import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=5b4bd55e&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=js&"
export * from "./Security.vue?vue&type=script&lang=js&"
import style0 from "./Security.vue?vue&type=style&index=0&id=5b4bd55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bd55e",
  null
  
)

export default component.exports